import { render, staticRenderFns } from "./ShopItemVirtualPlacement.vue?vue&type=template&id=50805f38&scoped=true&"
import script from "./ShopItemVirtualPlacement.vue?vue&type=script&lang=js&"
export * from "./ShopItemVirtualPlacement.vue?vue&type=script&lang=js&"
import style0 from "./ShopItemVirtualPlacement.vue?vue&type=style&index=0&id=50805f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50805f38",
  null
  
)

export default component.exports